import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
import config from '../../config'
import { BB13ApplicationStatusInterface } from '../../models/interfaces/bb13ApplicationStatus.interface'
import { PolymerCrypto } from '../../utils/encryptor'

interface QueryParams {
  hdb_ref: string[]
  uinfin: string
  singpass_token: string
}

export const bb13ApplicationStatusApi = createApi({
  reducerPath: 'bb13ApplicationStatusApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER, 
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "POST");
    headers.set("X-Content-Type-Options", "nosniff");
    headers.set("x-api-key", `${config.xApiKey}`);
  }}),
  endpoints: (builder) => ({
    getBB13Application: builder.query<BB13ApplicationStatusInterface[], QueryParams>({
      query: (queryParams:QueryParams) => ({
        method: "POST",
        headers: {
          uinfin:queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
        body: {
          "uinfin": PolymerCrypto.encryption(queryParams.uinfin),
          "hdb_refs": queryParams.hdb_ref
        },
        url:`${SUB_PATH_BASIC}/api/v1/hdb/bb13/checkCurrentCases`,
      }),
      transformResponse:(response: BB13ApplicationStatusInterface[], meta, arg)=>{
        const invalidBb13Status = ["", "X"];
        return response.filter(e=> !invalidBb13Status.includes(e.status));
      },
      keepUnusedDataFor:1,
    }),
  }),
})

export const { useGetBB13ApplicationQuery } = bb13ApplicationStatusApi
